import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  mobileRoot: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: "10px 16px",
    margin: 14,
    backgroundColor: "#f7f7f7",
    borderRadius: 4,
    boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.10)",
    "&:nth-child(odd)": {
      backgroundColor: "#f6f6f6"
    }
  },
  mobileHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  mobileFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12
  },
  horseName: {
    textTransform: "uppercase",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  horseExamInfo: {
    fontSize: 13,
    [theme.breakpoints.down(Breakpoints.MD_960)]: {
      maxWidth: 220
    },
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      maxWidth: "none"
    }
  },
  examLabel: {
    wordBreak: "break-all"
  },
  lineWidget: {
    marginBottom: 14,
    marginTop: -20,
    "& > div:first-child": {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 16,
      textAlign: "right",
      marginBottom: 8
    }
  }
}));
